/// <amd-module name="Artifacts/Cargo/components/CargoPackageAttributes" />
import { CargoFeatures } from "Artifacts/Cargo/components/CargoFeatures";
import { ICargoProtocolMetadata } from "Artifacts/Cargo/ICargoProtocolMetadata";
import * as CargoRes from "Artifacts/Cargo/Resources";
import { PackageDependencies } from "Artifacts/Package/components/package-details-common/PackageDependencies";
import {
  IProjectAttribute,
  PackageDevelopment,
} from "Artifacts/Package/components/package-details-common/PackageDevelopment";
import { PackageProvenance } from "Artifacts/Package/components/package-details-common/PackageProvenance";
import { PackageStats } from "Artifacts/Package/components/package-details-common/PackageStats";
import { PackageTags } from "Artifacts/Package/components/package-details-common/PackageTags";
import * as PackageRes from "Artifacts/Package/Resources";
import { IProtocolOverviewProps } from "Artifacts/Root/protocols/types";
import * as React from "react";
import { isFeatureFlagEnabled } from "VSS/Platform/Feature";
import { useComponentContext } from "VSS/Platform/Layout";

const CargoAttributes: React.FC<IProtocolOverviewProps> = ({ feed, pkg, version }) => {
  const { pageContext } = useComponentContext();
  const isProvenanceEnabled = isFeatureFlagEnabled(
    pageContext,
    "Packaging.Feed.WebAccess.Provenance",
    false,
  );
  const isMetricsEnabled = isFeatureFlagEnabled(
    pageContext,
    "Packaging.Feed.WebAccess.Metrics",
    false,
  );

  const cargoMetadata: ICargoProtocolMetadata = version.protocolMetadata?.data || {};

  const projectAttributes: IProjectAttribute[] = [];

  if (cargoMetadata.homepageUrl) {
    projectAttributes.push({
      iconClass: "Globe",
      text: CargoRes.CargoHomepageUrl_Title,
      url: cargoMetadata.homepageUrl,
    } as IProjectAttribute);
  }

  if (cargoMetadata.documentationUrl) {
    projectAttributes.push({
      iconClass: "Globe",
      text: CargoRes.CargoDocumentationUrl_Title,
      url: cargoMetadata.documentationUrl,
    } as IProjectAttribute);
  }

  if (cargoMetadata.repositoryUrl) {
    projectAttributes.push({
      iconClass: "Globe",
      text: CargoRes.CargoRepositoryUrl_Title,
      url: cargoMetadata.repositoryUrl,
    } as IProjectAttribute);
  }

  if (cargoMetadata.licenseExpression) {
    projectAttributes.push({
      iconClass: "Script",
      text: cargoMetadata.licenseExpression,
    } as IProjectAttribute);
  }

  return (
    <section className="package-overview-attributes" aria-label={PackageRes.PackageMetadata}>
      <div className="cargo-overview-attributes-panel">
        <PackageProvenance
          pageContext={pageContext}
          feed={feed}
          packageId={pkg.id}
          versionId={version.id}
          publishDate={new Date(version.publishDate)}
          isProvenanceEnabled={isProvenanceEnabled}
          isProvenanceSupported={false}
        />

        <PackageDevelopment
          pageContext={pageContext}
          projectAttributes={projectAttributes}
          packageSummary={pkg}
          packageVersion={version}
          upstreamSources={feed.upstreamSources}
        />

        {isMetricsEnabled && (
          <PackageStats
            pageContext={pageContext}
            feed={feed}
            package={pkg}
            versionId={version.id}
            isMetricsEnabled={isMetricsEnabled}
          />
        )}
        <PackageDependencies
          pageContext={pageContext}
          feed={feed}
          packageSummary={pkg}
          packageVersion={version}
          dependencyHelperCallback={undefined}
        />

        <PackageTags tags={version.tags} title={CargoRes.PackageTags_Title_Cargo} />
        <PackageTags title={PackageRes.PackageDetails_VersionsTable_Views} tags={version.views} />

        {cargoMetadata.categories && (
          <PackageTags tags={cargoMetadata.categories} title={CargoRes.CargoCategories_Title} />
        )}

        {cargoMetadata.features && (
          <CargoFeatures features={cargoMetadata.features} title={CargoRes.CargoFeatures_Title} />
        )}
      </div>
    </section>
  );
};

export { CargoAttributes };
